document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper(".image-gallery-swiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        watchOverflow: true,
        pagination: {
            el: ".swiper-pagination",
            type: 'fraction'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
});